export default "__VITE_ASSET__DkAvkpSd__"